export const gantt = {
    currentProcess: '当前进度 :',
    day: '第{curProcess}天',
    rest: '剩余天数 :',
    postpone: '延期 :',
    days: '天',
};
